export class ActionArgs
{
    constructor(
    public actionName: string,
    public data: any,
    public caller:any) {}    
}


// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/modules/crud/model/ActionArgs.ts